define('common/js/lib/Serum.Session',[],function () {
  'use strict';

  var s;

  try {
    s = window.sessionStorage;
  } catch(e) {
    console.error(e); // eslint-disable-line no-console
  }

  var isSupported = (function() {
    if (!s || !window.JSON || !window.JSON.stringify) {
      return false;
    }

    try {
      if (!s.getItem('Serum')) {
        s.setItem('Serum', JSON.stringify({}));
      }
      return true;
    } catch (e) {
      return false;
    }
  })();

  if (isSupported) {

    return {
      get : function(key){
        return JSON.parse(s.getItem('Serum'))[key];
      },
      set : function(key, value) {
        var c = JSON.parse(s.getItem('Serum'));
        c[key] = value;
        s.setItem('Serum', JSON.stringify(c));
      },
      remove : function(key) {
        var c = JSON.parse(s.getItem('Serum'));
        delete c[key];
        s.setItem('Serum', JSON.stringify(c));
      }
    };
  }
  var noop = function() {};
  return {
    get : function(){
      return {
        diff:0
      };
    },
    set : noop,
    remove : noop
  };
});

